import React from 'react';

import BriefcaseIcon from '@atlaskit/icon/core/briefcase';

export const ToneProfessionalIcon = () => (
	<BriefcaseIcon label="" color="currentColor" spacing="spacious" />
);
